// External libraries
import React from 'react';
import { useStoreState } from '@/store';
import { PasswordInput as Password } from '@checkout/react-components';

// Internal libraries
import { useMountLogging } from '@/lib/reactHooks';
import { getContent, getLocale } from '@/lib';
import { CountryCodes } from '@/generated/graphql';

const PasswordInput = props => {
  useMountLogging('PasswordInput');
  const { country } = getLocale();
  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);
  const isUpgradeInterstitialOpen = useStoreState(
    ({ ui }) => ui.isUpgradeInterstitialOpen,
  );
  const password = useStoreState(({ form }) => form.password);
  const firstName = useStoreState(({ form }) => form.firstName);
  const lastName = useStoreState(({ form }) => form.lastName);
  const dateOfBirth = useStoreState(({ form }) => form.dateOfBirth);

  let user;
  if (country === CountryCodes.Au) {
    user = {
      dateOfBirth: dateOfBirth?.value,
      firstName: firstName?.value,
      lastName: lastName?.value,
    };
  }

  return (
    <Password
      allowRawValue={true}
      checkMarkTitle={getContent('accessibility.requirementMet')}
      countryCode={country}
      disabled={isUpgradeInterstitialOpen ? false : isFormSubmitting}
      hintsContent={{
        fourConsecutiveChars: getContent('fieldErrors.passwordFourConsecutive'),
        fourRepeatedChars: getContent('fieldErrors.passwordFourRepeated'),
        infoSec: getContent('fieldErrors.passwordInfoSecViolation'),
        noDoubleByte: getContent('fieldErrors.passwordInvalidChars'),
        noInvalidChars: getContent('fieldErrors.passwordInvalidChars'),
        noInvalidSymbol: getContent('fieldErrors.passwordInvalidSymbol'),
        specialChar: getContent('fieldErrors.passwordSpecialChars'),
        tooLong: getContent('fieldErrors.passwordLength'),
        tooShort: getContent('fieldErrors.passwordLength'),
      }}
      label={getContent('fieldLabels.password')}
      pattern=".*[\d!@#$%^&*|]+.*"
      showButtonAriaLabel={{
        hide: getContent('accessibility.hidePassword'),
        show: getContent('accessibility.showPassword'),
      }}
      showButtonIcon={true}
      user={user}
      {...password}
      {...props}
    />
  );
};

export { PasswordInput };
